/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Hero_SubtitleInputs */

const en_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zero platform fees, your own domain, unlimited listings, all on Sovereign.`)
};

const es_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cero comisiones de plataforma, tu propio dominio, anuncios ilimitados — todo en Sovereign.`)
};

const fr_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zéro frais de plateforme, votre propre domaine, annonces illimitées — tout sur Sovereign.`)
};

const de_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Plattformgebühren, deine eigene Domain, unbegrenzte Inserate — alles auf Sovereign.`)
};

const ja_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラットフォーム手数料ゼロ、独自ドメイン、出品数無制限 — すべてSovereignで実現します。`)
};

const zh_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`零平台费，自定义域名，无限制商品——尽在 Sovereign。`)
};

const ar_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بدون رسوم منصة، نطاقك الخاص، إعلانات غير محدودة — كل ذلك في Sovereign.`)
};

const id_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nol biaya platform, domain Anda sendiri, listing tak terbatas — semua ada di Sovereign.`)
};

const it_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zero commissioni di piattaforma, dominio personalizzato, annunci illimitati — tutto su Sovereign.`)
};

const ru_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нулевые сборы платформы, собственный домен, неограниченное количество объявлений — всё это на тарифе Sovereign.`)
};

const pt_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zero taxas de plataforma, seu próprio domínio, anúncios ilimitados — tudo no Sovereign.`)
};

const ko_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랫폼 수수료 제로, 맞춤형 도메인, 무제한 상품 등록 — 이 모든 것이 Sovereign에 있습니다.`)
};

/**
* | output |
* | --- |
* | "Zero platform fees, your own domain, unlimited listings, all on Sovereign." |
*
* @param {Pricing_Hero_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_hero_subtitle = /** @type {((inputs?: Pricing_Hero_SubtitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Hero_SubtitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_hero_subtitle(inputs)
	if (locale === "es") return es_pricing_hero_subtitle(inputs)
	if (locale === "fr") return fr_pricing_hero_subtitle(inputs)
	if (locale === "de") return de_pricing_hero_subtitle(inputs)
	if (locale === "ja") return ja_pricing_hero_subtitle(inputs)
	if (locale === "zh") return zh_pricing_hero_subtitle(inputs)
	if (locale === "ar") return ar_pricing_hero_subtitle(inputs)
	if (locale === "id") return id_pricing_hero_subtitle(inputs)
	if (locale === "it") return it_pricing_hero_subtitle(inputs)
	if (locale === "ru") return ru_pricing_hero_subtitle(inputs)
	if (locale === "pt") return pt_pricing_hero_subtitle(inputs)
	return ko_pricing_hero_subtitle(inputs)
});